<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="国内自定义套餐" name="first">
        <AgentCommonProduct></AgentCommonProduct>
      </el-tab-pane>
      <el-tab-pane label="国际自定义套餐" name="second">
        <AgentInternationalProduct></AgentInternationalProduct>
      </el-tab-pane>
      <el-tab-pane label="卡自定义套餐" name="third">
        <CardCommonProduct></CardCommonProduct>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import AgentInternationalProduct from "./AgentInternationalProduct.vue";
import AgentCommonProduct from "./AgentCommonProduct.vue";
import CardCommonProduct from "./CardCommonProduct.vue";

export default {
  name: "AgentProduct",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    AgentInternationalProduct,
    AgentCommonProduct,
    CardCommonProduct

  },
  created() {
  },
};
</script>